import api from '../client'

/**
 * Paginated, searchable AcHeads (Chart of Accounts) option fetcher for AppCombobox lazy loading.
 * Calls /options/acheads with optional group filtering, 3-char search, and on-scroll pagination.
 * Returns { items: [{ value, label, id, name, code, group }], hasMore: boolean }
 */
export async function fetchAccountHeadOptions(search = '', page = 1, pageSize = 20, group = null) {
  const params = { search, page, page_size: pageSize }
  if (group) params.group = group
  const { data } = await api.get('/options/acheads', { params })
  const items = Array.isArray(data?.items) ? data.items : []
  const hasMore = Boolean(data?.has_more ?? (items.length === pageSize))
  return { items, hasMore }
}
